import { createSlice } from "@reduxjs/toolkit";
export const deviceSlice = createSlice({
    name: 'device',
    initialState: {
        DeviceUser: null,
        Pass: null,
        Realm: null,
        Display: null,
        smsNumbers: [],
        deviceReady: false,
    },
    reducers: {
        setDeviceCredentials: (state, action) => {
            return { ...state, ...action.payload, deviceReady: true };
        },
        setSMSNumbers: (state, action) => {
            state.smsNumbers = action.payload;

        },
        clearDeviceCredentials: (state) => {
            state.DeviceUser = null;
            state.Pass = null;
            state.Realm = null;
            state.Display = null;
            state.smsNumbers = [];
            state.deviceReady = false;
        },
    }
});
export const {
    setDeviceCredentials,
    setSMSNumbers,
    clearDeviceCredentials,
} = deviceSlice.actions;

//Selectors
export const selectDevice = (state) => state.device;
export const selectSMSNumbers = (state) => state.device.smsNumbers;
export const selectDeviceReady = (state) => state.device.deviceReady;
export default deviceSlice.reducer;